// SurveyPage.jsx
import React, { useState } from "react";
import { supabase } from "./supabase";
import { translations } from "./translations";

export default function SurveyPage() {
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [showShare, setShowShare] = useState(false);

  const params = new URLSearchParams(window.location.search);
  const getBool = (name) => params.get(name) === "true";

  // ==================================================
  // LANGUAGE (EN + HE ONLY)
  // ==================================================
  const lang = (
    params.get("lang") ||
    "en"
  );

  const isRTL = ((lang === "he") || (lang === "ar") || (lang === "fa"));

  const t = translations[lang] || translations.en;


  // ==================================================
  // STEP 1 AUTO DATA (NEW SCHEMA V2)
  // ==================================================
  const baseData = {
    uid:
      params.get("uid") || "",

    version:
      params.get("version") || "",

    installation_date:
      params.get("instalationdate") || "",

    download_count:
      Number(
        params.get("numofdownloads")
      ) || 0,

    popup_mode:
      getBool("popupmode"),

    language:
      lang,


  // =========================
  // SIZE FILTERS
  // =========================
  width_min: Number(params.get("widthmin")) || null,
  width_max: Number(params.get("widthmax")) || null,
  height_min: Number(params.get("heightmin")) || null,
  height_max: Number(params.get("heightmax")) || null,

  // =========================
  // FILE TYPES
  // =========================
  type_jpeg: getBool("type_jpeg"),
  type_png: getBool("type_png"),
  type_webp: getBool("type_webp"),
  type_gif: getBool("type_gif"),
  type_bmp: getBool("type_bmp"),
  type_svg: getBool("type_svg"),
  type_tiff: getBool("type_tiff"),
  type_avif: getBool("type_avif"),
  type_ico: getBool("type_ico"),
  type_other: getBool("type_other"),

  // =========================
  // FILTER SETTINGS
  // =========================
  url_include: getBool("include"),
  url_filter: getBool("urlfilter"),
  image_version: params.get("imgver"),

  // =========================
  // FOLDER / FILE SETTINGS
  // =========================
  folder_auto: getBool("folderauto"),
  folder_prefix_has_txt: getBool("folderprefixhastxt"),
  file_auto: getBool("fileauto"),
  file_prefix_has_txt: getBool("fileprefixhastxt"),

  // =========================
  // LAYOUT / UI
  // =========================
  layout_operator: params.get("layoutoportor") || "",
  ratio: Number(params.get("ratio")) || null,
  display_width: Number(params.get("displaywidth")) || null,
  theme: params.get("theme") || "",

  // =========================
  // CONVERSION SETTINGS
  // =========================
  convert_jpeg: params.get("conjpeg") || "",
  convert_png: params.get("conpng") || "",
  convert_webp: params.get("conwebp") || "",
  convert_gif: params.get("congif") || "",
  convert_bmp: params.get("conbmp") || "",
  convert_svg: params.get("consvg") || "",
  convert_tiff: params.get("contiff") || "",
  convert_avif: params.get("conavif") || "",
  convert_ico: params.get("conico") || ""
  };


  // ==================================================
  // STEP 2 USER DATA
  // ==================================================
  const [form, setForm] = useState({
    user_browser: "",
    user_os: "",
    web_speed: "",
    usage_frequency: "",
    purpose: "",
    translation_issues: "",
    bugs: "",
    improvements: "",
    knows_side_panel: "",
    knows_conversion: "",
    rating: 0,
    anything_else: ""
  });

  function handleChange(e) {
    const { name, value } =
      e.target;

    setForm((prev) => ({
      ...prev,
      [name]: value
    }));
  }

  // ==================================================
  // SUBMIT STEP 1
  // ==================================================
  async function allowCollection() {
    
    setLoading(true);

    const { error } =
      await supabase
        .from(
          "user_submissions"
        )
        .insert([baseData]);

    setLoading(false);

    if (error) {
      alert(error.message);
      return;
    }

    setStep(2);
  }

  // ==================================================
  // SUBMIT STEP 2
  // ==================================================
  async function submitStep2(e) {
    e.preventDefault();

    setLoading(true);

    const { error } =
      await supabase
        .from(
          "user_submissions"
        )
        .update(form)
        .eq(
          "uid",
          baseData.uid
        );

    setLoading(false);

    if (error) {
      alert(error.message);
      return;
    }

    setStep(3);
  }
  const rateUrl =
  "https://suricata.software/survey-image_downloader-review/" +
  baseData.version +
  "/0/" +
  lang+"/"+baseData.download_count;
// ===============================
// SHARE CONFIG
// ===============================
const shareUrl = "https://suricata.software/share-image_downloader/" + lang;
const shareText = "Check out this extension!";

  // ==================================================
  // SHARE
  // ==================================================
function shareExtension() {
  if (false && navigator.share) {
    navigator
      .share({
        title: "Extension",
        text: shareText,
        url: shareUrl
      })
      .catch(() => {});
  } else {
    setShowShare(true);
  }
}
// ===============================
// COPY LINK
// ===============================
function copyShareLink() {
  navigator.clipboard.writeText(shareUrl);
  alert("Link copied");
}


// ===============================
// STYLE OBJECT
// ADD WITH OTHER STYLES
// ===============================
const shareBtn = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 8,
  textDecoration: "none",
  padding: "12px",
  background: "#1a1a1a",
  border: "1px solid #333",
  color: "#fff",
  borderRadius: 10,
  cursor: "pointer",
  fontSize: 15
};

  // ==================================================
  // STYLES
  // ==================================================
const page = {
  minHeight: step === 3 ? "auto" : "100vh",
  background: "#000",
  color: "#fff",
  padding: "40px",
  display: "flex",
  justifyContent: "center",
  alignItems: step === 3 ? "center" : "flex-start",
  fontFamily: "Arial, sans-serif"
};

  const box = {
    width: "100%",
    maxWidth: "840px",
    background: "#111",
    border:
      "1px solid #222",
    borderRadius:
      "14px",
    padding: "32px"
  };

  const input = {
    width: "100%",
    padding: "12px",
    marginTop: "6px",
    marginBottom:
      "18px",
    borderRadius:
      "8px",
    border:
      "1px solid #333",
    background:
      "#1a1a1a",
    color: "#fff"
  };

  const button = {
    width: "100%",
    padding: "14px",
    border: "none",
    borderRadius:
      "10px",
    background:
      "#2563eb",
    color: "#fff",
    cursor:
      "pointer"
  };

  const barWrap = {
    width: "100%",
    height: "6px",
    background:
      "#222",
    borderRadius:
      "999px",
    overflow:
      "hidden",
    marginBottom:
      "22px"
  };

  const barFill = {
    width:
      step === 1
        ? "50%"
        : "100%",
    height: "100%",
    background:
      "linear-gradient(90deg,#2563eb,#60a5fa)",
    transition:
      ".35s"
  };
  const formatMonthYear = (dateString) => {
  if (!dateString) return "";

  const date = new Date(dateString);

  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long"
  });
};

  // ==================================================
  // THANK YOU PAGE
  // ==================================================
  if (step === 3) {
 return (
    <div style={page}>
      <div
        style={box}
        dir={isRTL ? "rtl" : "ltr"}
      >
        <h2>{t.thanks}</h2>

        <p>
          {t.done}{" "}
          <strong>
            {formatMonthYear(baseData.installation_date)}
          </strong>{" "}
          {t.pressed}{" "}
          <strong>{baseData.download_count}</strong>{" "}
          {t.times}
        </p>

<button
  title={t.share}
  onClick={shareExtension}
  style={{
    ...button,
    marginTop: "20px",
    width: "auto",
    padding: "10px 14px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px",
    transition: "all 0.2s ease"
  }}
>
  <img
    src="../assets/survey-icons/share-icon.svg"
    alt="share"
    style={{
      width: 20,
      height: 20,
      filter: "invert(1)",
      opacity: 0.95
    }}
  />
  <span>{t.Share_extension}</span>
</button>
  {form.rating === 5 && (
<button
  onClick={() => (window.location.href = rateUrl)}
  style={{
    ...button,
    marginTop: "20px",
    marginLeft: "24px",
    marginRight: "24px",
    width: "auto",
    padding: "10px 14px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px"
  }}
>
  <img
    src="../assets/survey-icons/rate-us.svg"
    alt="rate"
    style={{
      width: 20,
      height: 20,
      filter: "invert(1)",
      opacity: 0.95
    }}
  />
  <span>{t.Rate_us}</span>
</button>
)}
      </div>

      {showShare && (
        <div
          onClick={() => setShowShare(false)}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,.75)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
            padding: 20
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              width: "100%",
              position: "relative",
              maxWidth: 420,
              background: "#111",
              border: "1px solid #333",
              borderRadius: 18,
              padding: 24
            }}
          >
            <h2
              style={{
                marginTop: 0,
                marginBottom: 18,
                textAlign: "center"
              }}
            >
              Share the Extension
            </h2>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: 12
              }}
            >
<a
  target="_blank"
  rel="noreferrer"
  href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}`}
  style={shareBtn}
>
  <img
    src="../assets/survey-icons/linkedin-icon.svg"
    alt="LinkedIn"
    style={{
      width: 18,
      height: 18,
      opacity: 0.9
    }}
  />
  LinkedIn
</a>

<a
  target="_blank"
  rel="noreferrer"
  href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}&url=${encodeURIComponent(shareUrl)}`}
  style={shareBtn}
>
  <img
    src="../assets/survey-icons/x-icon.svg"
    alt="X"
    style={{
      width: 18,
      height: 18,
      filter: "invert(1)",
      opacity: 0.9
    }}
  />
  Twitter
</a>

<a
  target="_blank"
  rel="noreferrer"
  href={`https://wa.me/?text=${encodeURIComponent(shareText + " " + shareUrl)}`}
  style={shareBtn}
>
  <img
    src="../assets/survey-icons/whatsapp-icon.svg"
    alt="WhatsApp"
    style={{
      width: 18,
      height: 18,
      opacity: 0.9
    }}
  />
  WhatsApp
</a>

<a
  href={`mailto:?subject=${encodeURIComponent("Extension")}&body=${encodeURIComponent(shareText + " " + shareUrl)}`}
  style={shareBtn}
>
  <img
    src="../assets/survey-icons/email-icon.svg"
    alt="email"
    style={{
      width: 18,
      height: 18,
            filter: "invert(1)",
      opacity: 0.9
    }}
  />
  email
</a>

<a
  target="_blank"
  rel="noreferrer"
  href={`https://t.me/share/url?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent(shareText)}`}
  style={shareBtn}
>
  <img
    src="../assets/survey-icons/telegram-icon.svg"
    alt="Telegram"
    style={{
      width: 18,
      height: 18,
      opacity: 0.9
    }}
  />
  Telegram
</a>

<a
  target="_blank"
  rel="noreferrer"
  href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`}
  style={shareBtn}
>
  <img
    src="../assets/survey-icons/fb-icon.svg"
    alt="Facebook"
    style={{
      width: 18,
      height: 18,
      opacity: 0.9
    }}
  />
  Facebook
</a>

<a
  target="_blank"
  rel="noreferrer"
  href={`https://www.reddit.com/submit?url=${encodeURIComponent(shareUrl)}&title=${encodeURIComponent(shareText)}`}
  style={shareBtn}
>
  <img
    src="./assets/survey-icons/reddit-icon.svg"
    alt="Reddit"
    style={{
      width: 18,
      height: 18,
      opacity: 0.9
    }}
  />
  Reddit
</a>

              <button
                onClick={copyShareLink}
                style={shareBtn}
              >
                🔗 Copy Link
              </button>
              {(lang=="ja" || lang=="vi") && (
  <>
    <a
      target="_blank"
      rel="noreferrer"
      href={`https://social-plugins.line.me/lineit/share?url=${encodeURIComponent(shareUrl)}`}
      style={shareBtn}
    >
      <img src="../assets/survey-icons/line-icon.svg" style={{ width: 18, height: 18 }} />
      LINE
    </a>

    <a
      target="_blank"
      rel="noreferrer"
      href={`https://zalo.me/share?url=${encodeURIComponent(shareUrl)}`}
      style={shareBtn}
    >
      <img src="../assets/survey-icons/zalo-icon.svg" style={{ width: 18, height: 18 }} />
      Zalo
    </a>
  </>
)}
            </div>

<button
  onClick={() => setShowShare(false)}
  style={{
    position: "absolute",
    top: 12,
    right: 12,
    width: 34,
    height: 34,
    border: "none",
    borderRadius: "50%",
    background: "#1f1f1f",
    color: "#fff",
    fontSize: 20,
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    lineHeight: 1
  }}
>
  ×
</button>

          </div>

        </div>
        
      )}

    </div>
  );
  }

  // ==================================================
  // MAIN
  // ==================================================
  return (
    <div style={page}>
      <div
        style={box}
        dir={
          isRTL
            ? "rtl"
            : "ltr"
        }
      >
        <div
          style={barWrap}
        >
          <div
            style={barFill}
          />
        </div>

        <div
          style={{
            marginBottom:
              "20px",
            opacity: 0.8
          }}
        >
          {step === 1
            ? t.step1
            : t.step2}
        </div>

        {/* STEP 1 */}
        {step === 1 && (
          <>
            <h2>
              {t.title1}
            </h2>

            <p>
              {t.desc1}
            </p>

            <h4>
              {t.collect}
            </h4>

            <ul>
              <li>{t.collect1}</li>
              <li>{t.collect2}</li>
              <li>{t.collect3}</li>
              <li>{t.collect4}</li>
              <li>{t.collect5}</li>
            </ul>
<br/><br/><br/>
            <button
              style={
                button
              }
              onClick={
                allowCollection
              }
            >
              {loading
                ? "..."
                : t.allow}
            </button>
          </>
        )}

        {/* STEP 2 */}
        {step === 2 && (
          <form
            onSubmit={
              submitStep2
            }
          >
            <h2>
              {t.title2}
            </h2>

            {/* Browser */}
            <label>
              {t.browser}
            </label>
            <select
              name="user_browser"
              value={
                form.user_browser
              }
              onChange={
                handleChange
              }
              style={
                input
              }
            >
              <option value="">
                {t.no}
              </option>
              <option value="chrome">Chrome</option>
              <option value="edge">Edge</option>
              <option value="firefox">Firefox</option>
              <option value="opera">Opera</option>
              <option value="brave">Brave</option>
              <option value="vivaldi">Vivaldi</option>
              <option value="arc">Arc</option>
              <option value="other">{t.Other}</option>
            </select>

            {/* OS */}
            <label>
              {t.os}
            </label>
            <select
              name="user_os"
              value={
                form.user_os
              }
              onChange={
                handleChange
              }
              style={
                input
              }
            >
              <option>
                {t.no}
              </option>
              <option value="win11">
                Windows 11
              </option>
              <option value="win10−">
                {t.Windows_10_or_older}
              </option>
              <option value="osx">OSX</option>
              <option value="cromeos">
                ChromeOS
              </option>
              <option value="linux">Linux</option>
              <option value="other">{t.Other}</option>
            </select>

            {/* Speed */}
            <label>
              {t.speed}
            </label>
            <select
              name="web_speed"
              value={
                form.web_speed
              }
              onChange={
                handleChange
              }
              style={
                input
              }
            >
              <option value="">
                {t.no}
              </option>
              <option value="<1">
                {t.Less_than_1_Mbps}
              </option>
              <option value="1-2.49">
                1 - 2.49 Mbps
              </option>
              <option value="2.5-9.9">
                2.5 - 9.9 Mbps
              </option>
              <option value="10-49.9">
                10 - 49.9 Mbps
              </option>
              <option value="50-100">
                50 - 100 Mbps
              </option>
              <option value=">100">
                {t.More_than_100_Mbps}
              </option>
            </select>

            {/* Frequency */}
            <label>
              {t.freq}
            </label>
            <select
              name="usage_frequency"
              value={
                form.usage_frequency
              }
              onChange={
                handleChange
              }
              style={
                input
              }
            >
              <option value="">
                {t.no}
              </option>
              <option value="Daily">{t.Daily}</option>
              <option value="Weekly">{t.Weekly}</option>
              <option value="Monthly">{t.Monthly}</option>
              <option value="Rarely">{t.Rarely}</option>
            </select>

            {/* Purpose */}
            <label>
              {t.purpose}
            </label>
            <textarea
              name="purpose"
              value={
                form.purpose
              }
              onChange={
                handleChange
              }
              style={
                input
              }
            />

            {/* Translation */}
            <label>
              {t.translation}
            </label>
            <textarea
              name="translation_issues"
              value={
                form.translation_issues
              }
              onChange={
                handleChange
              }
              style={
                input
              }
            />

            {/* Bugs */}
            <label>
              {t.bugs}
            </label>
            <textarea
              name="bugs"
              value={
                form.bugs
              }
              onChange={
                handleChange
              }
              style={
                input
              }
            />

            {/* Improvements */}
            <label>
              {t.improve}
            </label>
            <textarea
              name="improvements"
              value={
                form.improvements
              }
              onChange={
                handleChange
              }
              style={
                input
              }
            />

            {/* Popup */}
            {baseData.popup_mode && (baseData.version !== "firefox") && (
              <>
                <label>
                  {t.side}
                </label>
                <select
                  name="knows_side_panel"
                  value={
                    form.knows_side_panel
                  }
                  onChange={
                    handleChange
                  }
                  style={
                    input
                  }
                >
                  <option value="">
                    {t.na}
                  </option>
                  <option value="y">
                    {t.yes}
                  </option>
                  <option value="n">
                    {t.no2}
                  </option>
                </select>
              </>
            )}

            {/* Conversion */}
            <label>
              {t.convert}
            </label>
            <select
              name="knows_conversion"
              value={
                form.knows_conversion
              }
              onChange={
                handleChange
              }
              style={
                input
              }
            >
              <option value="">
                {t.na}
              </option>
              <option value="y">
                {t.yes}
              </option>
              <option value="n">
                {t.no2}
              </option>
            </select>

            {/* Rating */}
            <label>
              {t.rate}
            </label>

            <div
              style={{
                display:
                  "flex",
                gap: "10px",
                fontSize:
                  "34px",
                marginTop:
                  "8px",
                marginBottom:
                  "22px",
                cursor:
                  "pointer",
                userSelect:
                  "none"
              }}
            >
              {[1,2,3,4,5].map(
                (
                  star
                ) => (
                  <span
                    key={
                      star
                    }
                    onClick={() =>
                      setForm(
                        (
                          prev
                        ) => ({
                          ...prev,
                          rating:
                            star
                        })
                      )
                    }
                    style={{
                      color:
                        form.rating >=
                        star
                          ? "#facc15"
                          : "#444"
                    }}
                  >
                    ★
                  </span>
                )
              )}
            </div>

            {/* Anything */}
            <label>
              {t.anything}
            </label>
            <textarea
              name="anything_else"
              value={
                form.anything_else
              }
              onChange={
                handleChange
              }
              style={
                input
              }
            />

            <button
              type="submit"
              style={
                button
              }
            >
              {loading
                ? "..."
                : t.submit}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}